import {Helmet} from "react-helmet";
import cinematography from '../assets/about/cinematography.jpg'
import photography from '../assets/about/photography.jpg'
import talent from '../assets/about/talent-development.jpg'
import total from '../assets/about/total-logo.png'
import gordons from '../assets/about/gordons.png'
import fresh from '../assets/about/so-fresh.png'
import ekiti from '../assets/about/ekiti-logo.png'
import oldLagos from '../assets/about/old-lagos.png'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import homeDocumentary from '../assets/home/documentary.jpg'
import homeWedding from '../assets/home/wedding4.jpg'
import homeEvent from '../assets/home/event1.jpg'
import video from '../assets/home/video.jpg'
import aboutHero from '../assets/home/tpj4s.jpg'



const About = () => {

	// hover section
	const triggerElements = document.querySelectorAll('.hover-trigger');
	const imagePlaceholders = document.querySelectorAll('.image-placeholder');

	triggerElements.forEach((triggerElement, index) => {
	  triggerElement.addEventListener('mouseenter', () => {
	    imagePlaceholders.forEach((imagePlaceholder, imageIndex) => {
	      if (imageIndex === index) {
	        imagePlaceholder.classList.remove('hidden');
	      } else {
	        imagePlaceholder.classList.add('hidden');
	      }
	    });
	  });
	});

	// Keep the currently displayed image when not hovering over any trigger
	imagePlaceholders.forEach((imagePlaceholder, imageIndex) => {
	  imagePlaceholder.addEventListener('mouseenter', () => {
	    triggerElements[imageIndex].classList.add('hover:underline');
	  });

	  imagePlaceholder.addEventListener('mouseleave', () => {
	    triggerElements[imageIndex].classList.remove('hover:underline');
	  });
	});


	return (
		<>
			<Helmet>
	    	    <title>About Glintz Media | Premium UK Visual Storytellers</title>
		        <meta name="description" content="Led by Creative Director Temitope Jalekun, our UK photography agency documents authentic love stories and refined commercial narratives with precision" />
		    </Helmet>
			<Navbar />
			<div className="">
				{/* First section - About Detail */}
				<div className="grid grid-cols-1 lg:grid-cols-2 gap-10 xl:gap-20 w-full py-20 xl:px-20 lg:px-20 px-10 items-center">
					
					{/* Left Column: Text Content */}
					<div className="text-left order-2 lg:order-1">
						
						<div className="space-y-6 text-custom-gray-text leading-relaxed" style={{fontFamily: "Muli"}}>
							<h2 className="uppercase pb-2 xl:text-4xl lg:text-4xl md:text-4xl text-3xl text-custom-gray-head-text">Meet the Creative Director: Temitope Jalekun</h2>
							<p>Every agency needs a distinct vision, and ours is driven by Temitope Jalekun, a dynamic wedding and portrait photographer, educator, and creative director based in the UK.</p>
							
							<p>Temitope's corporate portfolio includes directing campaigns for major brands and government institutions, including Stanbic IBTC Bank, Haier Thermocool, PENCOM, and the Ekiti State Government. </p>
							
							<p>His precise eye for detail has earned his work features on premier global platforms like CNN, Bellanaija, LoveweddingsNg, and Big Brother Nigeria.</p>
							
							<p>Temitope teaches and mentors emerging photographers as the founder of The Creative Quarters Africa (TCQ). He also hosts the TCQ podcast, sharing insights on the intersection of art, business, and storytelling.</p>
							
							<p>Temitope is a proud member of the British Institute of Professional Photography (BIPP).</p>

						</div>
					</div>

					{/* Right Column: Image (Matching Bedge Pictures style) */}
					<div className="order-1 lg:order-2">
						<img 
							src={aboutHero} // You can use the photography import or a specific "About Me" portrait
							alt="Glintz Media Story" 
							className="w-full h-auto object-cover shadow-sm grayscale hover:grayscale-0 transition duration-700"
							style={{ maxHeight: '700px' }} // Keeps the vertical image from getting too tall
						/>
					</div>
				</div>

				<div className="xl:px-40 px-10 lg:px-20 py-20">
					<h2 className="uppercase text-center pb-20 xl:text-4xl lg:text-4xl md:text-4xl text-3xl text-custom-gray-head-text">Our Style</h2>
					<p className="text-center text-custom-gray-text text-xl max-w-3xl mx-auto mb-16">
						Our visual language is clean, considered, and timeless. Guided by the belief that true luxury lies in simplicity and intentionality, we focus heavily on detail, composition, and emotion. This deliberate pacing allows us to craft imagery that reveals the essence of every subject and preserves moments with absolute clarity and depth.
					</p>
					<div className="grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-3 gap-10">
						<div>
							<img src={photography} alt="photographer" className="mb-5" />
							<h3 className="uppercase mb-5 xl:text-2xl lg:text-2xl md:text-2xl text-xl text-custom-gray-head-text tracking-[.1em]">Professional Photographer</h3>
							<p className="text-custom-gray-text" style={{fontFamily: "Muli"}}>We create and document timeless images in elegant and simple form. Whether on a busy commercial set or a quiet wedding morning, the camera acts as an extension of our observation, catching the subtle interactions that matter most.</p>
						</div>
						<div>
							<img src={cinematography} alt="cinematographer" className="mb-5" />
							<h3 className="uppercase mb-5 xl:text-2xl lg:text-2xl md:text-2xl text-xl text-custom-gray-head-text tracking-[.1em]">Cinematography and Film Production</h3>
							<p className="text-custom-gray-text" style={{fontFamily: "Muli"}}>Moving images allow us to tell your story in a deeply personal way. Film requires a different kind of pacing, and our cinematographers are trained to build narratives that sound just as good as they look.</p>
						</div>
						<div>
							<img src={talent} alt="talent developer" className="mb-5" />
							<h3 className="uppercase mb-5 xl:text-2xl lg:text-2xl md:text-2xl text-xl text-custom-gray-head-text tracking-[.1em]">Creative Talent Developmen</h3>
							<p className="text-custom-gray-text" style={{fontFamily: "Muli"}}>Through The Creative Quarters Africa (TCQ), we actively inspire and empower creative talents. Passing down technical knowledge and business acumen ensures the next generation of visual artists is fully equipped to master their craft.</p>
						</div>
					</div>
				</div>


				<div className="xl:flex lg:flex md:flex grid grid-cols-1 xl:pl-10 ">
					<div className="my-auto order-2 xl:order-1 lg:order-1 md:order-1 px-10 xl:px-20 lg:px-0 md:px-0">
						<ul className="uppercase text-custom-gray-text tracking-[.15em] xl:text-4xl lg:text-4xl md:text-3xl sm:text-2xl text-2xl">
							<li className="py-4 hover:underline"><a href="/portfolio/portrait" className="hover-trigger" data-target="portrait">portrait</a></li>
							<li className="py-4 hover:underline"><a href="/portfolio/wedding" className="hover-trigger" data-target="wedding">wedding</a></li>
							<li className="py-4 hover:underline"><a href="/portfolio/events" className="hover-trigger" data-target="events">events</a></li>
							<li className="py-4 hover:underline"><a href="/portfolio/documentary" className="hover-trigger" data-target="documentary">documentary</a></li>
							<li className="py-4 hover:underline"><a href="/portfolio/commercial" className="hover-trigger" data-target="commercial">commercial</a></li>
						</ul>
					</div>
					<div className="order-1 xl:order-2 lg:order-2 md:order-2 px-10 xl:px-0 lg:px-0 md:px-0">
						<img src={video} 
							alt="portrait"
					      className="image-placeholder"
					      data-target="portrait"
					     />
						<img
					      src={homeWedding}
					      alt="wedding"
					      className="hidden image-placeholder"
					      data-target="wedding"
					    />
					    <img
					      src={homeEvent}
					      alt="events"
					      className="hidden image-placeholder"
					      data-target="events"
					    />
					    <img
					      src={homeDocumentary}
					      alt="documentary"
					      className="hidden image-placeholder"
					      data-target="documentary"
					    />
					    <img
					      src={homeEvent}
					      alt="commercial"
					      className="hidden image-placeholder"
					      data-target="commercial"
					    />
					</div>
				</div>


			{/*brands*/}
			<div className="xl:-mt-20 grid 
				xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 
				bg-custom-light-bg xl:py-40 lg:py-40 md:py-20 py-20 
				xl:px-64 lg:px-30 md:px-30 justify-center ">
				<div className="flex justify-center items-center mb-5 xl:mb-0 lg:mb-0 md:mb-0 sm:mb-0">
					<img src={total} alt="" className="xl:w-3/6 lg:w-3/6 w-2/6" />
				</div>
				<div className="flex justify-center items-center mb-5 xl:mb-0 lg:mb-0 md:mb-0 sm:mb-0">
					<img src={gordons} alt="" className="xl:w-3/6 lg:w-3/6 w-2/6" />
				</div>
				<div className="flex justify-center items-center mb-5 xl:mb-0 lg:mb-0 md:mb-0 sm:mb-0">
					<img src={fresh} alt="" className="xl:w-3/6 lg:w-3/6 w-2/6" />
				</div>
				<div className="flex justify-center items-center">
					<img src={ekiti} alt="" className="xl:w-3/6 lg:w-3/6 w-2/6" />
				</div>
				<div className="flex justify-center items-center">
					<img src={oldLagos} alt=""  />
				</div>
			</div>

				{/*follow on socials section*/}
				<div className="grid grid-cols-1 text-center py-20 px-4 hover:bg-custom-dark-gray-bg transition">
					<h1 
						className="
							xl:text-4xl lg:text-4xl md:text-3xl text-2xl tracking-[.25em] uppercase mb-5 
							text-white">
							follow us on instagram
					</h1>
					<p className="mb-2 text-white italic text-xl">
						<a href="https://www.instagram.com/glintzweddingphotography?igsh=MTJibTkyZzhjczljeg==">@glintzweddingphotography</a></p>
					<p className="text-white italic text-xl">
						<a href="https://www.instagram.com/glintz_studios/">@glintz_studios</a></p>
				</div>

			</div>
			<Footer />
		</>
	)
}

export default About